import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ru from "vee-validate/dist/locale/ru";

Vue.use(VueI18n)
function loadLocaleMessages() {
  const locales = require.context('./locales/messages', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: {
    ru: {
      field: {
        username: "никнейм",
        email: "email",
        password: "пароль",
        password_confirm: "подтвержденный пароль",
        first_name: "имя",
        last_name: "фамилия",
        job_title: "должность",
        user: "пользователь",
        permission: 'разрешение',
        object: "обьект",
        name: "название",
        number: "номер",
        railway: "железная дорога",
        sector: "участок",
        station: "станция",
        object_type: "тип обьекта"
      },
      message: loadLocaleMessages(),
      validation: ru.messages,
    }
  }
})
